module.exports = __webpack_public_path__ + "img/cup-hot.1bc76fbe.svg";